
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import { sharedState } from '../../../../framework/state';

import { CustomerMakesReport } from '../../../../../common/application/model/report/CustomerMakesReport';
import { formatNumber } from '../../../service/helper_service';

@Component
export default class VehicleMakeTable extends Vue {
    @Prop(Array) readonly rows!: CustomerMakesReport[];

    shared = sharedState;

    local = {
        averageCo2: 0,
        totalVehicles: 0,
    };

    mounted() {
        this.initValues();
    }

    @Watch('rows')
    rowsChanged() {
        this.initValues();
    }

    private initValues() {
        this.local.averageCo2 = 0;
        this.local.totalVehicles = 0;
        this.local.averageCo2 = this.averageCo2;
        this.local.totalVehicles = this.totalVehicles;
    }

    private get totalVehicles(): number {
        let total = 0;

        if (!this.rows.length) {
            return total;
        }

        for (const row of this.rows) {
            total += parseInt(row.count);
        }

        return total;
    }

    private get averageCo2(): number {
        let total = 0;

        if (!this.rows.length) {
            return total;
        }

        for (const row of this.rows) {
            total += row.co2average;
        }

        return Math.round(total / this.rows.length);
    }

    formatNumberValue(value: number): string {
        return formatNumber(value);
    }
}
